import { MessageBodyTypeEnum } from '@vendorflow/types/lib/types/Messages'
import ms from 'ms'

export enum ToolsEnum {
  WATCHERS = 'Watchers',
  USER_PROFILE = 'UserProfile',
  NEW_CONTACT = 'NewContact',
  SHIPMENT_INFO = 'ShipmentInfo',
  MEDIA = 'Media',
  E_MANIFEST_CAPTURE = 'EManifestCapture',
  ELD = 'ELD',
}
export const CONTACT_GROUP_LIMIT_MIN = 200
export const LONG_STALE_TIME = ms('60d')
export const LONG_CACHE_TIME = ms('61d')
export const FIVE_MINUTES = ms('5m')

export const VENDOR_MISSING_PHONE_TOOLTIP = 'Vendor is missing a phone number.'
export const DASHBOARD_DRAWER_WIDTH = 256
export const SUPPRESSED_MESSAGE_BODIES = [MessageBodyTypeEnum.CHATBOT_STATUS]
export const NIL_UUID = '00000000-0000-0000-0000-000000000000'
